import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';

import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/cities/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/cities/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/cities/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadCities(query, limit) {
  return {
    [RSAA]: {
      ...api.getCities(query, limit),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE]
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: []
};

export default function citiesReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      };
    default:
      return state;
  }
}


// ------------------------------------
// Selectors
// ------------------------------------
// export function getCities(globalState) {
//   return globalState.cities.data.map(city => {
//     return {
//       value: `${city.city}|${city.province}`,
//       label: `${city.city} (${city.province})`
//     };
//   });
// }